import { Component, Input } from '@angular/core';
import './exploreSnapshotWidgetsNg2.html';

@Component({
  selector: 'explore-snapshot-widgets-ng2',
  template : require("./exploreSnapshotWidgetsNg2.html")
})

export class ExploreSnapshotWidgetsComponentNg2 {
  @Input() activeChartsTab: string;
  @Input() widgetsData: any;
  @Input() isNoGroupLoadedAndPristineFilters: boolean = true;

  breakdownConfigs = {
    age: {
      metric: 'age'
    },
    country: {
      metric: 'country'
    },
    apps: {
      metric: 'apps'
    },
    genre: {
      metric: 'genre'
    },
    income: {
      metric: 'income'
    }
  };

  constructor() {}

  ngOnInit() {}
}


/** WEBPACK FOOTER **
 ** ./src/components/explore/exploreSnapshotWidgetsNg2.ts
 **/